module.exports = __webpack_public_path__ + "media/images/emblems/Reutigen-coat_of_arms-2fc2e8e7735c744d333a735ecd71af23.svg";